<template>
  <accordion-item-fi
    v-if="hasTextList || approvals || icons"
    class="accordion-application-authorisation-fi"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Application-And-Authorisation') }}
    </template>
    <template #content>
      <div class="accordion-application-authorisation-fi__content">
        <div
          v-if="textListValue(textList, 'KAT_ANWENDUNG_GEN')"
          class="accordion-application-authorisation-fi__column accordion-application-authorisation-fi--application"
        >
          <richtext-fi
            class="accordion-application-authorisation-fi__text"
            :html-content="{ value: textListValue(textList, 'KAT_ANWENDUNG_GEN') }"
          />
        </div>
        <div
          v-if="textListValue(textList, 'KAT_BAUSTOFF_GEN')"
          class="accordion-application-authorisation-fi__column accordion-application-authorisation-fi--material"
        >
          <richtext-fi
            class="accordion-application-authorisation-fi__text"
            :html-content="{ value: textListValue(textList, 'KAT_BAUSTOFF_GEN') }"
          />
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="accordion-application-authorisation-fi__material-disclaimer"
            v-html="materialDisclaimer"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
        <div
          v-if="approvals"
          class="accordion-application-authorisation-fi__column accordion-application-authorisation-fi--approval"
        >
          <div class="accordion-application-authorisation-fi__text">
            <div class="h10">
              {{ $dict.get('product-Catalog.Accordions.Authorisation') }}
            </div>

            <richtext-fi>
              <ul>
                <li
                  v-for="item in approvals"
                  :key="item"
                >
                  {{ item }}
                </li>
              </ul>
            </richtext-fi>
          </div>
        </div>
        <div
          v-if="icons"
          class="accordion-application-authorisation-fi__column accordion-application-authorisation-fi--icons"
        >
          <div
            v-for="icon in icons"
            :key="icon.Url"
            class="accordion-application-authorisation-fi__icon"
          >
            <cloud-image-fi
              :src="icon.Url"
              :alt="icon.Label"
              height="45"
              params="func=bound"
              do-not-replace-url
            />
          </div>
        </div>
      </div>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi, CloudImageFi, RichtextFi } from 'atoms';

import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogMixin from '@/mixins/catalogMixin.vue';

export default {
  name: 'AccordionApplicationAuthorisationFi',
  components: {
    AccordionItemFi,
    CloudImageFi,
    RichtextFi,
  },
  mixins: [breakpointMixin, catalogMixin],
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    textList() {
      return this.catalogData?.TextList;
    },
    hasTextList() {
      return (
        this.textListValue(this.textList, 'KAT_ANWENDUNG_GEN') ||
        this.textListValue(this.textList, 'KAT_BAUSTOFF_GEN')
      );
    },
    materialDisclaimer() {
      return this.$dict
        .get('product-Catalog.Block-Labels.Application-and-Permission.Materials-Disclaimer', [
          this.$fischer.pages.downloadCenter().url,
        ])
        .replace('{url}', this.$fischer.pages.downloadCenter().url);
    },
    approvals() {
      const approvals = [];

      if (this.catalogData?.Documents?.Approvals) {
        this.catalogData.Documents.Approvals.forEach((approval) => {
          if (approval.nr) {
            approvals.push(approval.nr);
          }
        });

        if (approvals.length) {
          return approvals;
        }
      }

      return null;
    },
    icons() {
      const media = this.catalogData?.Media;
      if (!media) {
        return null;
      }

      const icons = media.filter(
        (o) => o.OutputType === 'PR' && (o.Type === 'Icon' || o.Type === 'Logo'),
      );

      if (!icons.length) {
        return null;
      }

      return icons;
    },
  },
};
</script>

<style src="./accordion-application-authorisation-fi" />
